import React, {useEffect} from 'react';
import {renderFilterProps} from '../../../components/ListingController';
import FilterFormsLayout from './FilterFormsLayout';
import {Col, Form, Row} from 'react-bootstrap';
import TextInput from '../../fields/TextInput';
import ButtonComponent from '../../../components/ButtonComponent';
import {useForm} from 'react-hook-form';
import SelectInput, {SelectInputOptions} from '../../fields/SelectInput';

interface FilterProps extends renderFilterProps {}

const selectInputOptions: SelectInputOptions[] = [
    {label: 'Oui', value: 'true'},
    {label: 'Non', value: 'false'},
    {label: 'Tous', value: 'all'},
];

const UserFilter = ({onFilter, onReset, defaultValues}: FilterProps) => {
    const methods = useForm({defaultValues: defaultValues});
    const {
        handleSubmit,
        register,
        reset,
        control,
        watch,
        getFieldState,
    } = methods;

    const activeFilters = Object.entries(watch())
        // retire les champs qui ont leurs valeurs par défaut
        .filter(([key]) =>
            getFieldState(key).isDirty && key !== 'page'
        )
    ;

    useEffect(() => {
        reset(defaultValues, {keepDefaultValues: true});
    }, [defaultValues, reset]);

    return (
        <FilterFormsLayout
            activeFilters={activeFilters.length}
            renderForm={(toggleCollapsePanel: any) =>
                <Form onSubmit={handleSubmit(onFilter)}>
                    <Row>
                        <Col lg={4}>
                            <TextInput name={'clients+name'} register={register}
                                       label={'Client'}
                                       containerClass={'mb-3'}
                                       control={control}/>
                        </Col>
                        <Col lg={4}>
                            <TextInput name={'firstname'} register={register}
                                       label={'Prénom'} containerClass={'mb-3'}
                                       control={control}/>
                        </Col>
                        <Col lg={4}>
                            <TextInput name={'lastname'} register={register}
                                       label={'Nom'} containerClass={'mb-3'}
                                       control={control}/>
                        </Col>
                        <Col lg={4}>
                            <TextInput name={'email'} register={register}
                                       label={'Email'} containerClass={'mb-3'}
                                       control={control}/>
                        </Col>
                        <Col lg={4}>
                            <SelectInput name={'userProjectEnabled'} register={register}
                                         label={'Actif ?'}
                                         containerClass={'mb-3'}
                                         selectOptions={selectInputOptions}
                                         control={control}
                                         placeholder={'Tous'}/>
                        </Col>
                    </Row>

                    <Row className={'justify-content-end'}>
                        <Col lg={4} className="text-end">
                            <ButtonComponent buttonType={'submit'}
                                             buttonLabel={'Rechercher'}
                                             buttonIcon={'fas fa-search'}
                                             handleClickEvent={() => toggleCollapsePanel()}/>

                            <ButtonComponent buttonType={'button'}
                                             buttonLabel={'Réinitialiser'}
                                             buttonIcon={'fas fa-redo-alt'}
                                             classes={'btn-secondary ms-1'}
                                             handleClickEvent={() => {
                                                 reset();
                                                 onReset();
                                                 toggleCollapsePanel();
                                             }}/>
                        </Col>
                    </Row>

                </Form>
            }
        />
    );
};

export default UserFilter;